import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Trans } from '@lingui/macro';
import dayjs from 'dayjs';

import styled from 'styled-components';
import { SelectWrapper, DayPickerInputWrapper } from '@lib/final-form-oca-ui';
import { FileUploaderField } from '@features/common';
import { dateTokens } from '@lib/i18n';
import { DocumentCard, IndexBadge } from './document-card';

const datePickerOptions = {
  formatDate: date => dayjs(date).format('L'),
};

export function FieldsetContract({ name, index, onDelete, options }) {
  return (
    <DocumentCard
      title={
        <React.Fragment>
          <Trans>Signed contract</Trans>
          {index ? (
            <React.Fragment>
              {' '}
              <IndexBadge>{index}</IndexBadge>
            </React.Fragment>
          ) : null}
        </React.Fragment>
      }
      onRemove={onDelete ? () => onDelete(index) : undefined}
    >
      <FormGrid>
        <FormCol>
          <Field
            name={`${name}.docType`}
            component={SelectWrapper}
            label={<Trans>Type</Trans>}
            parse={value => (value ? value.id : '')}
            format={value => options.find(({ id }) => value === id)}
            options={options}
            required
          />
        </FormCol>
        <FormCol>
          <Field
            name={`${name}.expDate`}
            component={DayPickerInputWrapper}
            parse={val => (val ? dayjs(val).format(dateTokens.ISO_DATE) : '')}
            format={val => (val ? new Date(val).toISOString() : null)}
            label={<Trans>Expire date</Trans>}
            options={datePickerOptions}
            required
          />
        </FormCol>
        <FormCol>
          <FileUploaderField
            label={<Trans>Picture / scan</Trans>}
            name={`${name}.files`}
          />
        </FormCol>
      </FormGrid>
    </DocumentCard>
  );
}

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  align-items: flex-start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const FormCol = styled.div`
  width: 100%;
  min-width: 0;
`;

FieldsetContract.propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  index: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  onDelete: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
};

FieldsetContract.defaultProps = {
  options: [],
};
